'use strict';

import {waitForDependencies} from "../../_imports/utils/utils.common";
const metaNavRoot = document.querySelector('.header_top .meta-navigation');

const initSubmenuTriggers = () => {
    const metaNavButton = '.parent-menu-link button';
    const $metaNav = $('.meta-navigation');
    const $subMenuParents = $metaNav.find(metaNavButton);

    $subMenuParents.each(function() {
        $(this).on('mouseover', function() {
            const $subMenu = $(this).parent().find('.submenu');

            $(this).addClass('active');
            $subMenu.addClass('visible');
        });
    });
};

const detectCloseSubmenu = () => {
    metaNavRoot?.addEventListener('mouseout', e => {
        const target = e.toElement || e.relatedTarget;
        const isValidTarget = target?.matches('li:not(.has-children), li:not(.has-children) > a[href]');

        if (!metaNavRoot.contains(target) || isValidTarget) {
            closeSubmenu();
        }
    });
};

const closeSubmenu = () => {
    const $metaNav = $('.meta-navigation');
    const $subMenus = $metaNav.find('.submenu.visible');
    
    if($subMenus.length) {
        const subMenu = $subMenus[0];
        const $trigger = $(subMenu).parent().find('[data-submenu="trigger"]');
        
        if (subMenu && $trigger) {
            $(subMenu).removeClass('visible');
            $trigger.removeClass('active');
            $('body').removeClass('nav-open');
        }
    }
};

waitForDependencies(() => {
    if($('.header_top').length) {
        initSubmenuTriggers();
        detectCloseSubmenu();
    }
});